
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { KpiEnum } from '../../../enums'

import { UiTooltip } from '../../keen-ui'
import { EpbText } from '../../shared/epb-text'

export default defineComponent({
  name: 'KpiExpander',
  components: {
    EpbText,
    UiTooltip,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    core: {
      type: Object as PropType<{
        label: string
        values: [currentPeriod: number, comparePeriod: number]
      }>,
      required: true,
    },
    asides: {
      type: Array as PropType<
        Array<{
          label: string
          values: [currentPeriod: number, comparePeriod: number]
          orientation: string
          icon?: string
        }>
      >,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  mounted(): void {
    this.expanded = !!this.asides.length
  },
  methods: {
    hasComparedValue(periodsValues: Array<number>): boolean {
      return !!periodsValues && !!periodsValues[1]
    },
    getPeriodsDifference(periodsValues: Array<number>): number {
      const mainPeriodValue = periodsValues[0]
      const comparePeriodValue = periodsValues[1]
      const increaseValue = mainPeriodValue - comparePeriodValue
      return Math.round((increaseValue / (comparePeriodValue || 1)) * 100)
    },
    getCompareArrowIconClasses(periodsValues: Array<number>): string[] {
      const periodsDifference = this.getPeriodsDifference(periodsValues)
      const classes = [this.getValueColorClass(periodsDifference)]
      if (periodsDifference > 0) {
        classes.push('epb-kpi-expander__icon--arrow-up')
      }
      return classes
    },
    getPeriodValueText(periodValue: number, roundLongNumber?: boolean): string {
      return this.$epb.utils.formatNumber(
        periodValue,
        { maximumFractionDigits: 2 },
        roundLongNumber,
      )
    },
    getValueColorClass(value: number): string {
      const positiveClass = 'epb-kpi-expander__icon--positive'
      const negativeClass = 'epb-kpi-expander__icon--negative'
      if (this.id !== KpiEnum.NO_RESULTS) {
        return value > 0 ? positiveClass : negativeClass
      } else {
        return value < 0 ? positiveClass : negativeClass
      }
    },
  },
})
